export default "__VITE_ASSET__DBzJvzZC__"